import { z } from "zod";

export const waitFormSchema = z.object({
    active: z.boolean(),
    title: z.string(),
    subtitle: z.string(),
    // type: z.enum(["fixed_delay", "until_date"]), // TODO: BE only supports fixed delay (delay_seconds)
    delayValue: z
        .number({
            required_error: "components.connection-creator.nodes.wait.forms.delay_required",
            invalid_type_error: "components.connection-creator.nodes.wait.forms.delay_required",
        })
        .min(0, { message: "components.connection-creator.nodes.wait.forms.delay_min" })
        .max(31536000, { message: "components.connection-creator.nodes.wait.forms.delay_max" }),
    delayUnit: z.string().refine((value) => value === "seconds", {
        message: "components.connection-creator.nodes.wait.forms.seconds_only",
    }),
    // untilDate: z.string().nullable(), // TODO: Not supported by BE yet
});
